import React from "react";
import { Rect, Image as KonvaImage } from "react-konva";
import useImage from "use-image";
import { normalizeContainer } from "./coord";
import { ContainedElement } from "./ContainedElement";

const fitImageToContainer = (
  imageWidth,
  imageHeight,
  containerWidth,
  conatainerHeight,
  containerX,
  containerY,
  mode,
  padding
) => {
  if (padding) {
    containerWidth -= 2 * padding;
    conatainerHeight -= 2 * padding;
    containerX += padding;
    containerY += padding;
  }

  const scaleX = containerWidth / imageWidth;
  const scaleY = conatainerHeight / imageHeight;

  let scale;

  if (mode === "contain") {
    scale = Math.min(scaleX, scaleY);
  } else if (mode === "cover") {
    scale = Math.max(scaleX, scaleY);
  } else {
    return {
      x: containerX,
      y: containerY,
      width: containerWidth,
      height: conatainerHeight,
    };
  }

  const width = imageWidth * scale;
  const height = imageHeight * scale;
  const x = containerX + (containerWidth - width) / 2;
  const y = containerY + (conatainerHeight - height) / 2;

  return { x, y, width, height };
};

const Background = ({ x, y, width, height, backgroundImage }) => {
  const { src, fitMode, padding, ...bgImgSetup } = backgroundImage;
  const [image] = useImage(src, "anonymous");

  if (!image) return null;

  const imgCoords = fitImageToContainer(
    image.width,
    image.height,
    width,
    height,
    x,
    y,
    fitMode,
    padding
  );

  return (
    <KonvaImage opacity={0.7} image={image} {...imgCoords} {...bgImgSetup} />
  );
};

export const MyRect = ({
  x,
  y,
  width,
  height,
  coords,
  backgroundImage = {},
  children,
  ...props
}) => {
  let _coords = { x, y, width, height };
  if (coords) {
    _coords = normalizeContainer(coords);
  }

  return (
    <>
      <Rect {..._coords} {...props} />
      <Background {..._coords} backgroundImage={backgroundImage} />
      {React.Children.map(children, (child) => (
        <ContainedElement elem={child} container={_coords} />
      ))}
    </>
  );
};

MyRect.displayName = "MyRect";
